// extracted by mini-css-extract-plugin
export default {"main":"ShowCard_main__q0l+s","info_show_container":"ShowCard_info_show_container__iagO1"};